"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { SidebarIcon } from "lucide-react";
import Link from "next/link";
import React from "react";
import LastSyncedStatus from "@/components/layouts/LastSyncedStatus";
import { PremiumUpgradeHeaderCta } from "@/components/layouts/premium-upgrade/premium-upgrade-header-cta";
import { NotificationList } from "@/components/notifications/NotificationList";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { Skeleton } from "@/components/ui/skeleton";
import { TourHelpButton } from "@/features/onboarding-tours/components/tour-help-button";
import { TOUR_TARGETS } from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { toTitleCase } from "@/lib/utils";
export function AppHeader() {
  const $ = _c(6);
  const {
    toggleSidebar
  } = useSidebar();
  const {
    workspace,
    loading,
    workspaceId,
    currentView
  } = useCurrentWorkspace();
  let t0;
  if ($[0] !== currentView || $[1] !== loading || $[2] !== toggleSidebar || $[3] !== workspace || $[4] !== workspaceId) {
    const breadcrumbs = currentView.split("/");
    t0 = workspaceId && <header className="bg-sidebar/5 text-sidebar-foreground sticky top-0 z-50 flex w-full items-center border-b border-border/30 backdrop-blur-xl"><div className="flex h-(--header-height) w-full items-center pr-4"><div className="w-(--sidebar-width-icon) h-full flex items-center justify-center border-r border-border/30 mr-4"><Button aria-label="Toggle Sidebar" className="size-7 relative" data-sidebar="trigger" data-slot="sidebar-trigger" id={TOUR_TARGETS.sidebarTrigger} onClick={toggleSidebar} size="icon" variant="ghost"><span className="absolute top-1/2 left-1/2 size-12 -translate-1/2 pointer-fine:hidden" /><SidebarIcon /><span className="sr-only">Toggle Sidebar</span></Button></div><Breadcrumb className="hidden sm:block sm:shrink-0"><BreadcrumbList><BreadcrumbItem>{loading || !workspace ? <Skeleton className="h-4.5 w-20 bg-muted rounded-sm" /> : <BreadcrumbLink asChild={true}><Link className="pointer-events-none" href={`/${workspace?.id}`}>{workspace?.name}</Link></BreadcrumbLink>}</BreadcrumbItem>{currentView && workspace && breadcrumbs.map((segment, index) => {
              const isLast = index === breadcrumbs.length - 1;
              const path = currentView.split("/").slice(0, index + 1).join("/");
              const hasSpecialCharacters = /^(?=.*[0-9])(?=.*[^a-zA-Z0-9])/.test(segment);
              const urlName = hasSpecialCharacters ? segment : toTitleCase(segment);
              const childContent = isLast ? <BreadcrumbPage title={segment}>{urlName}</BreadcrumbPage> : <BreadcrumbLink asChild={true} title={segment}><Link href={`/${workspace?.id}/${path}`}>{urlName}</Link></BreadcrumbLink>;
              return <React.Fragment key={segment}><BreadcrumbSeparator /><BreadcrumbItem>{childContent}</BreadcrumbItem></React.Fragment>;
            })}</BreadcrumbList></Breadcrumb><div className="ml-auto flex items-center gap-2"><LastSyncedStatus /><PremiumUpgradeHeaderCta /><TourHelpButton /><NotificationList /></div></div></header>;
    $[0] = currentView;
    $[1] = loading;
    $[2] = toggleSidebar;
    $[3] = workspace;
    $[4] = workspaceId;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}